module.exports = __webpack_public_path__ + "static/media/13_stena_86.15_0.9d60a1a3.png";